import { render, staticRenderFns } from "./UploadOption.vue?vue&type=template&id=c89cc8e0"
import script from "./UploadOption.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadOption.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports